import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { CardEmptyComponent } from './card-empty.component';

@NgModule({
  declarations: [CardEmptyComponent],
  imports: [CommonModule, MatGridListModule, MatIconModule],
  exports: [CardEmptyComponent],
})
export class CardEmptyModule {}
